// Third-party
import React from 'react';
import classNames from 'classnames';

// Utils
import { ACTIVITIES, ACTIVITY_FORMAT, formatActivityData } from '../../../utils/activity-log';
import { formatMessage } from '../../../utils/i18n';
import { formatEventDate } from '../../../utils/time';
import Activity from '@/types/activity';

interface Props {
  activity: Activity;
  format: ACTIVITY_FORMAT;
  inline?: boolean;
}

const ActivityListItem = ({ activity, format, inline }: Props) => {
  const { i18nKey, color } = ACTIVITIES[activity.type];

  return (
    <div className={classNames('activity-list-item', { inline })}>
      <div className="date-container">
        <i className="icon-icon-circle" style={{ color }} />
        <span className="activity-date">{formatEventDate(activity.at)}</span>
      </div>
      <span className="activity-content" data-private data-dd-privacy="mask">
        {formatMessage(`ActivityLog.${i18nKey}.${format}`, formatActivityData(activity))}
      </span>
    </div>
  );
};

export default ActivityListItem;
